import React from 'react';
import ClientResourceManager from '../../components/admin/ClientResourceManager';

const AdminResourcesPage = () => {
  return (
    <div className="p-8">
      <ClientResourceManager />
    </div>
  );
};

export default AdminResourcesPage;
